type TEventData = Record<string, any>;

declare global {
  interface Window {
    FS?: {
      event: (name: string, data?: TEventData) => void;
    };
  }
}

export function useFullStory() {
  const trackFSEvent = (name: string, data?: TEventData) => {
    if (typeof window !== 'undefined' && window.FS?.event) {
      window.FS.event(name, data);
    } else {
      console.warn('[FullStory] Not initialized:', name, data);
    }
  };

  return { trackFSEvent };
}
